import { useEffect, useRef, useState } from "react";
import { LegalTocPanel } from "@/components/legal/LegalTocAside";

/**
 * Índice fijo en escritorio (lg+). Se oculta cuando el sentinel al final del artículo
 * entra en el viewport (el contenido ha terminado).
 *
 * RIGHT_CSS: alinea el borde derecho del panel con el padding derecho del contenedor
 * max-w-7xl (equivalente a px-12 en lg, más el margen exterior en pantallas muy anchas).
 */
const RIGHT_CSS = "max(3rem, calc((100vw - 80rem) / 2 + 3rem))";
const TOP_CSS = "calc(5.5rem + 0.5rem)";
const MAX_H_CSS = "calc(100dvh - 7.5rem)";

export default function LegalTocFixed({ sentinelRef, ariaLabel, tocItems, title }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const el = sentinelRef?.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => setVisible(!e.isIntersecting), {
      threshold: 0,
    });
    obs.observe(el);
    return () => obs.disconnect();
  }, [sentinelRef]);

  return (
    <div
      className="hidden lg:fixed lg:z-20 lg:block"
      style={{
        top: TOP_CSS,
        right: RIGHT_CSS,
        width: "16rem",
        maxHeight: MAX_H_CSS,
        overflowY: "auto",
        overscrollBehavior: "contain",
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
        transition: "opacity 0.2s ease",
      }}
    >
      <LegalTocPanel ariaLabel={ariaLabel} tocItems={tocItems} title={title} />
    </div>
  );
}
